import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';

import InfiniteScroll from '../../commons/InfiniteScroll';
import UserCard from '../../commons/UserCard';
import {
  FOLLOWERS_REQUESTED,
  FOLLOWERS_RETRIEVED,
  FOLLOWERS_FAILED
} from '../../redux/actions/types';
import { getFollowers } from '../../redux/actions/social';
import LoadingGif from '../../images/Loading.gif';

const styles = theme => ({
  followersList: {
    padding: theme.spacing(2),
    width: '100%',
    minHeight: '100vh',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'flex-start'
  },
  loadingSection: {
    padding: theme.spacing(2),
    width: '100%',
    minHeight: '100vh',
    display: 'flex',
    flexFlow: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  }
});

class Followers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      followers: [],
      loadingFollowers: false,
      hasMoreFollowers: false
    };
  }

  componentDidMount() {
    this.props.getFollowers(this.props.user);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.followersStatus !== this.props.followersStatus) {
      if (this.props.followersStatus === FOLLOWERS_REQUESTED) {
        this.setState({ loadingFollowers: true });
      }
      if (this.props.followersStatus === FOLLOWERS_RETRIEVED) {
        this.setState(state => ({
          followers: [...state.followers, ...this.props.followers],
          loadingFollowers: false,
          hasMoreFollowers: this.props.followers.length === 10
        }));
      }
      if (this.props.followersStatus === FOLLOWERS_FAILED) {
        this.setState({ loadingFollowers: false });
      }
    }
  }

  loadMore = page => {
    this.props.getFollowers(this.props.user, page);
  };

  render() {
    const { classes } = this.props;

    if (this.state.followers.length === 0 && this.state.loadingFollowers) {
      return (
        <div className={classes.loadingSection}>
          <img src={LoadingGif} alt="loading" />
          <Typography color="primary">Cargando Seguidoras...</Typography>
        </div>
      );
    }

    return (
      <div className={classes.followersList}>
        <InfiniteScroll
          loadMore={this.loadMore}
          pageStart={2}
          pageSize={1}
          hasMore={this.state.hasMoreFollowers}
          loading={this.state.loadingFollowers}
          threshold={1000}
        >
          {this.state.followers.map(follower => (
            <UserCard
              noProductsFetch
              key={follower.id}
              noProductsAllowed
              user={follower}
            />
          ))}
        </InfiniteScroll>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  followers: state.social.followers,
  followersStatus: state.social.status
});

const mapDispatchToProps = dispatch => ({
  getFollowers: (user, page) => dispatch(getFollowers(user, page))
});

export default withStyles(styles)(
  connect(mapStateToProps, mapDispatchToProps)(Followers)
);
